import React, { forwardRef } from "react";
import {
  AppBar,
  Container,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { WindowClose } from "mdi-material-ui";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PrivacyPolicy = ({ open, openHandler, closeHandler }) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={closeHandler}
      TransitionComponent={Transition}
    >
      <AppBar color="inherit">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={closeHandler}
            aria-label="cerrar"
          >
            <WindowClose />
          </IconButton>
          <Typography variant="h6">Política de privacidad</Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Container>
        <div className="sd-accordio-area pt-130 pb-130">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <iframe
                  src="/privacy.pdf"
                  style={{
                    width: "100%",
                    height: "85vh",
                    border: "none",
                    borderRadius: "8px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                  title="Política de Privacidad"
                  allow="fullscreen"
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Dialog>
  );
};

export default PrivacyPolicy;
